import React from 'react';
import { useNavigate } from 'react-router-dom';

// 이미지 임포트 (실제 경로에 맞게 수정하세요)
import bigImage1 from '../assets/images/home_products_001.png';
import bigImage2 from '../assets/images/home_products_002.png';

function ImageSection({ imageSrc, buttonText, buttonLink }) {
  const navigate = useNavigate();

  return (
    <div className="relative w-full h-auto lg:h-[600px] mb-16">
      {/* 배경 이미지 */}
      <img
        src={imageSrc}
        alt="섹션 이미지"
        className="w-full h-full object-cover"
      />
      {/* 흰색 오버레이 레이어 (알파값 50%) */}
      <div className="absolute inset-0 bg-white bg-opacity-20"></div>

      {/* 버튼: 절대 위치, 좌측 상단 100px 마진 */}
      {/* 버튼 - 반응형 위치 조정 */}
      <button
        onClick={() => navigate(buttonLink)}
        className="absolute lg:top-[100px] lg:left-[100px] 
                  inset-0 m-auto lg:m-0 w-fit h-fit
                  text-white 
                  bg-black bg-opacity-50 hover:bg-white
                  px-6 py-3 font-semibold text-xl 
                  hover:text-black transition-all"
      >
        {buttonText}
      </button>
    </div>
  );
}

export default function ProductSections() {
  return (
    <section className="max-w-7xl mx-auto px-4 py-20 border-t border-gray-300">
      {/* 첫 번째 이미지 섹션 */}
      <ImageSection
        imageSrc={bigImage1}
        buttonText="제품 보러가기"
        buttonLink="/human"
      />

      {/* 두 번째 이미지 섹션 */}
      <ImageSection
        imageSrc={bigImage2}
        buttonText="제품 보러가기"
        buttonLink="/animal"
      />
    </section>
  );
}
